var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetinBoyutuBuyuk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MetinBoyutu-Buyuk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-829.000000, -2579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MetinBoyutu-Buyuk",
    transform: "translate(829.000000, 2579.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.953125,19.203125 L7.62890625,14.4453125 L14.1796875,14.4453125 L15.890625,19.203125 L18.8671875,19.203125 L12.4570312,2 L9.41015625,2 L3,19.203125 L5.953125,19.203125 Z M13.4414062,12.03125 L8.44921875,12.03125 L9.99609375,7.56640625 C10.4023438,6.42578125 10.7109375,5.375 10.921875,4.4140625 C11,4.7265625 11.1425781,5.21875 11.3496094,5.890625 C11.5566406,6.5625 11.71875,7.0546875 11.8359375,7.3671875 L11.8359375,7.3671875 L13.4414062,12.03125 Z",
    id: "A",
    fill: "#464646",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetinBoyutuBuyuk);
export default __webpack_public_path__ + "static/media/MetinBoyutu-Buyuk.767aeb32512e1152f93afb9d141da291.svg";
export { ForwardRef as ReactComponent };